export default __webpack_public_path__ + "static/media/box-stack.c97e98f8.svg";